import {Status} from './status.model';
import {StandardType} from './standard-type.model';
import {AnswerGroupPos} from '../content-page/admin/create-operating-standard/tree-group-pos-service/answer-group-pos.model';

export class CreatingStandard {
  public creationDate: string;
  public standardType: any;
  public number: string;
  public authorId: string;
  public groupId: string;
  public ruAnnotation: string;
  public ruName: string;
  public ruType: string;
  public enAnnotation: string;
  public enName: string;
  public enType: string;
  public status: string;
  public linkedGroups: string[];
  public linkedUsers: string[];
  public linkedPositions: string[];
  public standardDisseminationPositions: AnswerGroupPos[] = []; // treeGroupPosService

  constructor(creationDate: string,
              standardType: any,
              number: string,
              authorId: string,
              groupId: string,
              ruAnnotation: string,
              ruName: string,
              ruType: string,
              enAnnotation: string,
              enName: string,
              enType: string,
              status: string,
              linkedGroups: string[],
              linkedUsers: string[],
              linkedPositions: string[],
              standardDisseminationPositions: AnswerGroupPos[]) {
    this.creationDate = creationDate;
    this.standardType = standardType;
    this.number = number;
    this.authorId = authorId;
    this.groupId = groupId;
    this.ruAnnotation = ruAnnotation;
    this.ruName = ruName;
    this.ruType = ruType;
    this.enAnnotation = enAnnotation;
    this.enName = enName;
    this.enType = enType;
    this.status = status;
    this.linkedGroups = linkedGroups;
    this.linkedUsers = linkedUsers;
    this.linkedPositions = linkedPositions;
    this.standardDisseminationPositions = standardDisseminationPositions;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/creating-standard.model.ts